const ShieldIcon = ({ strokeColor = '#808080' }) => (
  <svg
    viewBox="0 0 795.1 795.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <style>{`
        .cls-1 {
          fill: #fcfcfc;
        }
        .cls-2 {
          fill: #4d4d4d;
        }
        .cls-3 {
          stroke: ${strokeColor};
          stroke-width: 50px;
          fill: none;
          stroke-miterlimit: 10;
        }
        .cls-4 {
          stroke: #fff;
          stroke-width: 20px;
          fill: none;
          stroke-miterlimit: 10;
        }
      `}</style>
    </defs>

    <g>
      <circle className="cls-2" cx="397.55" cy="397.55" r="388.66" />
      <circle className="cls-3" cx="397.55" cy="397.55" r="372.55" />
      <circle className="cls-4" cx="397.55" cy="397.55" r="343.4" />
    </g>

    <g>
      <path
        className="cls-1"
        d="M383.16,626.72c-47.1-24.58-88.36-55.4-119.3-98.41-30.01-41.71-51.43-87.36-53.49-139.43-2.04-51.61-1.41-103.33-1.73-155-.06-9.52,5.25-13.38,16.67-15.71,27.99-5.71,56.22-10.69,83.71-18.29,29.16-8.05,57.39-19.03,83.02-35.94,3.53-2.33,11.57-1.55,15.45.98,39.13,25.43,82.4,39.53,127.76,48.16,12.27,2.33,24.71,3.79,36.97,6.14,10.74,2.05,14.21,6.19,14.22,16.82.04,42-.29,84-.14,126,.11,30.11-2.95,59.77-13.47,88.1-29.04,78.22-79.93,137.28-155,174.77-1.51.76-3.17,1.31-4.54,2.27-9.93,6.97-19.76,7.48-30.14-.46Zm-143.8-299.51c.64,22.55-.58,45.34,2.28,67.6,8.07,62.77,39.58,113.36,85.17,156,21.77,20.36,46.85,35.76,73.24,49.24,2.84-1.54,5.83-3.2,8.84-4.81,43.25-23.11,79.23-54.1,105.85-95.74,20.89-32.7,37.98-67.12,39.72-106.32,2.15-48.48,1.53-97.09,2.07-145.64,0-.47-.55-.95-.69-1.17-55.48-8-109.29-20.33-157.53-51.74-47.6,32.54-104.02,40.95-158.95,52.48v80.1Z"
      />
    </g>
  </svg>
);

export default ShieldIcon;